import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, RefreshCw } from 'lucide-react';
import Nouveautes from './Nouveautes';

// Feuille basse ouverte par « Plus » : toutes les pages accessibles, par
// section, puis l'état de la synchro. Fond et Échap ferment.

export default function MobileMoreSheet({ open, onClose, sections = [], sync }) {
  const location = useLocation();
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="lg:hidden fixed inset-0 z-50 flex items-end" role="dialog" aria-modal="true" aria-label="Toutes les pages">
      <button
        type="button"
        aria-label="Fermer"
        onClick={onClose}
        className="absolute inset-0 bg-[rgba(23,27,38,.35)] motion-voile"
      />

      <div className="relative w-full max-h-[85vh] overflow-y-auto bg-background rounded-t-[20px] px-4 pt-3 pb-[max(32px,env(safe-area-inset-bottom))] motion-montee">
        <span className="block w-10 h-1 rounded-sm bg-handle mx-auto mb-4" aria-hidden="true" />

        {sections.map(({ title, items }) => (
          <section key={title}>
            <p className="mt-3 mx-1 mb-1.5 text-[11px] font-bold uppercase tracking-[0.08em] text-foreground-tertiary">{title}</p>
            <div className="bg-card border border-border rounded-[14px] overflow-hidden divide-y divide-muted">
              {items.map(({ label, path, icon: Icon, tone }) => {
                const active = location.pathname === path;
                return (
                  <Link
                    key={path}
                    to={path}
                    onClick={onClose}
                    aria-current={active ? 'page' : undefined}
                    className={`flex items-center gap-3 min-h-[52px] px-4 text-[15px] ${
                      active ? 'bg-primary-soft text-primary-text font-extrabold' : 'text-foreground font-semibold'
                    }`}
                  >
                    <Icon className="w-[18px] h-[18px] flex-shrink-0" strokeWidth={2} style={{ color: tone }} aria-hidden="true" />
                    <span className="truncate">{label}</span>
                    <ChevronRight className="ml-auto w-4 h-4 text-border-strong flex-shrink-0" aria-hidden="true" />
                  </Link>
                );
              })}
            </div>
          </section>
        ))}

        {sync && (
          <div className="mt-4 p-3.5 rounded-[14px] bg-card border border-border flex items-center justify-between gap-3 text-[13px] font-bold">
            <span className="inline-flex items-center gap-2 min-w-0">
              <span className={`w-2 h-2 rounded-full flex-shrink-0 ${sync.status === 'error' ? 'bg-rose' : sync.status === 'syncing' ? 'bg-[#F59E0B]' : 'bg-[#10B981]'}`} aria-hidden="true" />
              <span className="truncate">{sync.label}{sync.time && !sync.isSyncing ? ` · ${sync.time}` : ''}</span>
            </span>
            <button
              type="button"
              onClick={sync.trigger}
              disabled={sync.isSyncing}
              className="inline-flex items-center gap-1.5 min-h-[44px] px-3.5 rounded-full bg-muted font-bold flex-shrink-0 appui disabled:opacity-40"
            >
              Forcer <RefreshCw className={`w-3.5 h-3.5 ${sync.isSyncing ? 'animate-spin' : ''}`} aria-hidden="true" />
            </button>
          </div>
        )}
        {/* Le journal des mises à jour : sur téléphone, la barre latérale qui le porte est cachée. */}
        <div className="mt-4 -mx-3"><Nouveautes /></div>
      </div>
    </div>
  );
}
